import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';

import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import ThemeProvider from './themes/ThemeProvider';

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
